import localFont from "next/font/local";

import { BUNDLED_TEMPLATE_FONT_SPECS } from "@/lib/bundled-template-fonts";

// MARK: bundled_next_fonts
/**
 * `next/font/local` requires **literal** `path` strings in each `localFont({ src })` call (Turbopack static analysis).
 * File layout must stay aligned with {@link BUNDLED_TEMPLATE_FONT_SPECS} and `public/assets/fonts/{catalog}/`.
 */
export const CourierPrime = localFont({
    src: [
        {
            path: "../../public/assets/fonts/courier_prime/courier_prime.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/courier_prime/courier_prime-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/courier_prime/courier_prime-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/courier_prime/courier_prime-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const DMSans = localFont({
    src: [
        {
            path: "../../public/assets/fonts/dm_sans/dm_sans.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/dm_sans/dm_sans-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/dm_sans/dm_sans-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/dm_sans/dm_sans-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Inter = localFont({
    src: [
        {
            path: "../../public/assets/fonts/inter/inter.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/inter/inter-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/inter/inter-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/inter/inter-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Lato = localFont({
    src: [
        {
            path: "../../public/assets/fonts/lato/lato.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/lato/lato-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/lato/lato-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/lato/lato-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const LibreFranklin = localFont({
    src: [
        {
            path: "../../public/assets/fonts/libre_franklin/libre_franklin.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/libre_franklin/libre_franklin-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/libre_franklin/libre_franklin-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/libre_franklin/libre_franklin-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Lora = localFont({
    src: [
        {
            path: "../../public/assets/fonts/lora/lora.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/lora/lora-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/lora/lora-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/lora/lora-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const MirandaSans = localFont({
    src: [
        {
            path: "../../public/assets/fonts/miranda_sans/miranda_sans.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/miranda_sans/miranda_sans-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/miranda_sans/miranda_sans-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/miranda_sans/miranda_sans-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Montserrat = localFont({
    src: [
        {
            path: "../../public/assets/fonts/montserrat/montserrat.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/montserrat/montserrat-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/montserrat/montserrat-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/montserrat/montserrat-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const OpenSans = localFont({
    src: [
        {
            path: "../../public/assets/fonts/open_sans/open_sans.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/open_sans/open_sans-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/open_sans/open_sans-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/open_sans/open_sans-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const PlayfairDisplay = localFont({
    src: [
        {
            path: "../../public/assets/fonts/playfair_display/playfair_display.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/playfair_display/playfair_display-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/playfair_display/playfair_display-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/playfair_display/playfair_display-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Poppins = localFont({
    src: [
        {
            path: "../../public/assets/fonts/poppins/poppins.otf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/poppins/poppins-italic.otf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/poppins/poppins-bold.otf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/poppins/poppins-bold-italic.otf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Raleway = localFont({
    src: [
        {
            path: "../../public/assets/fonts/raleway/raleway.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/raleway/raleway-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/raleway/raleway-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/raleway/raleway-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Roboto = localFont({
    src: [
        {
            path: "../../public/assets/fonts/roboto/roboto.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/roboto/roboto-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/roboto/roboto-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/roboto/roboto-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const RobotoCondensed = localFont({
    src: [
        {
            path: "../../public/assets/fonts/roboto_condensed/roboto_condensed.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/roboto_condensed/roboto_condensed-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/roboto_condensed/roboto_condensed-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/roboto_condensed/roboto_condensed-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const RobotoSerif = localFont({
    src: [
        {
            path: "../../public/assets/fonts/roboto_serif/roboto_serif.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/roboto_serif/roboto_serif-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/roboto_serif/roboto_serif-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/roboto_serif/roboto_serif-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Rubik = localFont({
    src: [
        {
            path: "../../public/assets/fonts/rubik/rubik.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/rubik/rubik-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/rubik/rubik-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/rubik/rubik-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const SourceSansPro = localFont({
    src: [
        {
            path: "../../public/assets/fonts/source_sans_pro/source_sans_pro.otf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/source_sans_pro/source_sans_pro-italic.otf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/source_sans_pro/source_sans_pro-bold.otf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/source_sans_pro/source_sans_pro-bold-italic.otf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Times = localFont({
    src: [
        {
            path: "../../public/assets/fonts/times/times.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/times/times-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/times/times-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/times/times-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});
export const Ubuntu = localFont({
    src: [
        {
            path: "../../public/assets/fonts/ubuntu/ubuntu.ttf",
            weight: "400",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/ubuntu/ubuntu-italic.ttf",
            weight: "400",
            style: "italic",
        },
        {
            path: "../../public/assets/fonts/ubuntu/ubuntu-bold.ttf",
            weight: "700",
            style: "normal",
        },
        {
            path: "../../public/assets/fonts/ubuntu/ubuntu-bold-italic.ttf",
            weight: "700",
            style: "italic",
        },
    ],
    display: "swap",
});

const bundled_next_font_by_catalog: Record<string, ReturnType<typeof localFont>> = {
    courier_prime: CourierPrime,
    dm_sans: DMSans,
    inter: Inter,
    lato: Lato,
    libre_franklin: LibreFranklin,
    lora: Lora,
    miranda_sans: MirandaSans,
    montserrat: Montserrat,
    open_sans: OpenSans,
    playfair_display: PlayfairDisplay,
    poppins: Poppins,
    raleway: Raleway,
    roboto: Roboto,
    roboto_condensed: RobotoCondensed,
    roboto_serif: RobotoSerif,
    rubik: Rubik,
    source_sans_pro: SourceSansPro,
    times: Times,
    ubuntu: Ubuntu,
};

// MARK: SYSTEM_SEGOE_UI_CSS_FONT_FAMILY
/**
 * Host OS font stack (Segoe UI ships on Windows). Template catalog `segoe` and app chrome use this — no bundled Segoe files.
 */
export const SYSTEM_SEGOE_UI_CSS_FONT_FAMILY =
    '"Segoe UI", "Segoe UI Variable", ui-sans-serif, system-ui, sans-serif';

// MARK: TemplateFontCatalogEntry
/** One row in {@link fontsList}: either a `next/font/local` face or a system `css_font_family`. */
export type TemplateFontCatalogEntry = {
    name: string;
    label: string;
    nextFont?: ReturnType<typeof localFont>;
    css_font_family?: string;
};

// MARK: template_font_css_family_value
/**
 * Value for Lexical `font-family` / inline styles: bundled entries use the real `next/font` CSS family
 * (`style.fontFamily`), system `segoe` uses `css_font_family`; last resort `name` (legacy catalog ids).
 */
export function template_font_css_family_value(entry: TemplateFontCatalogEntry): string {
    if (entry.css_font_family != null && entry.css_font_family !== "") {
        return entry.css_font_family;
    }
    const next_css_family = entry.nextFont?.style?.fontFamily;
    if (next_css_family != null && next_css_family !== "") {
        return next_css_family;
    }
    return entry.name;
}

// MARK: fontsList
/**
 * Catalog for template toolbar / PDF / DOCX. Bundled rows follow {@link BUNDLED_TEMPLATE_FONT_SPECS};
 * `segoe` is inserted after `rubik` (historical toolbar ordering).
 */
export const fontsList: TemplateFontCatalogEntry[] = (() => {
    const bundled_rows: TemplateFontCatalogEntry[] = BUNDLED_TEMPLATE_FONT_SPECS.map((spec) => ({
        name: spec.catalog_name,
        label: spec.label,
        nextFont: bundled_next_font_by_catalog[spec.catalog_name],
    }));
    const segoe_row: TemplateFontCatalogEntry = {
        name: "segoe",
        label: "Segoe",
        css_font_family: SYSTEM_SEGOE_UI_CSS_FONT_FAMILY,
    };
    const rubik_index = bundled_rows.findIndex((row) => row.name === "rubik");
    if (rubik_index === -1) {
        return [...bundled_rows, segoe_row];
    }
    return [...bundled_rows.slice(0, rubik_index + 1), segoe_row, ...bundled_rows.slice(rubik_index + 1)];
})();
